import { useEffect } from "react";

const Ayurveda = () => {
  useEffect(() => {
    document.title = "Ayurveda - Deww Botanicals";
  }, []);

  return (
    <>
      <div
        className="container-fluid page-header"
        style={{ backgroundImage: `url(../assets/images/ayurveda.jpg)` }}
      >
        <div className="container">
          <h1 className="display-5 mb-3 animated slideInDown">Ayurveda</h1>
        </div>
      </div>

      <div className="container-xxl py-3 container-fluid p-0 mb-5 blog-wrapper">
        <div className="container">
          <div className="row my-3">
            <div className="col-12 col-md-9 m-auto">
              <h2>The Power of Natural Oils in Ayurveda</h2>

    <p><strong>Ayurveda</strong> – Natural oils play a crucial role in Ayurveda, serving as essential components in various therapies, personal care, and medicinal formulations.</p>

    {/* <img src="https://source.unsplash.com/800x400/?ayurveda,natural-oil" alt="Ayurveda natural oil" /> */}

    <h2>Nurturing Wellness with Essential Oils and Carrier Oils</h2>

    <p>In Ayurvedic tradition, natural oils are considered powerful tools for healing, balance, and rejuvenation. Both essential oils and carrier oils play crucial roles in promoting physical, mental, and emotional well-being through time-tested therapies and herbal formulations.</p>

    <h3>Essential Oils: Aromatic Elixirs of Nature</h3>

    {/* <img src="https://source.unsplash.com/800x400/?essential-oils,flowers" alt="Essential oils in Ayurveda" /> */}

    <p>Extracted from flowers, leaves, bark, and roots, essential oils are concentrated plant essences known for their therapeutic properties. In Ayurveda, they are utilized for:</p>

    <ul>
      <li>Aromatherapy to calm the mind and balance doshas</li>
      <li>Skincare to treat acne, pigmentation, and inflammation</li>
      <li>Hair care to combat dandruff, promote hair growth, and revitalize the scalp</li>
      <li>Emotional wellness to reduce stress, anxiety, and fatigue through soothing fragrances</li>
    </ul>

    <p>Popular essential oils such as lavender, sandalwood, frankincense, and basil (tulsi) are widely used in Ayurvedic rituals and formulations due to their profound energetic and healing effects.</p>

    <h3>Carrier Oils: The Nourishing Foundation</h3>

    {/* <img src="https://source.unsplash.com/800x400/?carrier-oil,herbal" alt="Carrier oils Ayurveda" /> */}

    <p>Carrier oils are cold-pressed, nutrient-rich base oils that form the foundation of many Ayurvedic treatments. They are used to dilute essential oils and are often infused with medicinal herbs to create potent medicated oils known as <em>Tailams</em>.</p>

    <p>Common Ayurvedic applications include:</p>
    <ul>
      <li><strong>Abhyanga</strong> (Ayurvedic massage) using oils like sesame, coconut, or almond to nourish tissues, relieve stiffness, and detoxify the body</li>
      <li>Herbal infusions for treating skin disorders, joint pain, and scalp issues</li>
      <li>Internal oleation in Panchakarma therapies to lubricate the digestive tract and promote detoxification</li>
      <li>Daily skincare to moisturize, protect, and restore natural glow</li>
    </ul>

    <h2>A Harmonious Blend of Tradition and Nature</h2>

    {/* <img src="https://source.unsplash.com/800x400/?ayurveda,healing" alt="Ayurvedic healing" /> */}

    <p>Whether used alone or in combination, essential oils and carrier oils bring the therapeutic essence of nature into everyday wellness. At the heart of Ayurvedic practice, these natural oils serve as mediums to restore balance, vitality, and inner peace—the true essence of holistic health.</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Ayurveda;
